<template>
  <div>
    <el-dropdown trigger="click">
      <span class="el-dropdown-link p-2">
        <img
          class="relative p-1 mx-auto sticky-nav-450-shopping"
          src="../../../assets/images/shoppingcard.svg"
          alt="Shopping Card"
        />
        <span class="hover:text-teal-400 display-450">Warenkorb</span>
      </span>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item class="index-450">
          <a
            href="#"
            class="block px-4 py-2 font-semibold p-5"
            v-if="!getCart || getCart.length === 0"
          >{{ $t('EmptyCart') }}!</a>
          <router-link
            to="/cart"
            class="bg-teal-400 p-1 rounded text-white hover:text-teal-400 hover:bg-white"
            v-else
          >{{ $t('ViewCart')}}</router-link>
        </el-dropdown-item>
        <el-dropdown-item>
          <router-link
            to="/checkout"
            class="bg-teal-400 p-1 rounded text-white hover:text-teal-400 hover:bg-white"
            v-if="getCart && getCart.length != 0"
          >{{ $t('Checkout') }}</router-link>
        </el-dropdown-item>
        <el-dropdown-item></el-dropdown-item>
        <el-dropdown-item></el-dropdown-item>
        <el-dropdown-item></el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      isOpen: false,
      hasItems: false,
    };
  },
  computed: {
    ...mapGetters(["getCart"]),
  },
};
</script>

<style>
@media(max-width:600px){
  .display-450{
    display: none;
  }

  .el-dropdown-menu{
    z-index: 99999 !important;
    position: fixed !important;
  }
}
</style>